/*@flow*/
import mkDropdownTemplate from './mkDropdownTemplate';
import * as loaders from 'queries/loaders';
import getCompanyId from 'lib/getCompanyId';

export default (filterName: string): any =>
  mkDropdownTemplate({
    isMulti: true,
    isCreatable: true,
    loadValues: () =>
      loaders.projectTagLoader({ companyId: getCompanyId(), filterName }),
  });
